var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandPlot618(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M941.222 212.054L979.063 212.576L979.41 201.963L942.005 201.268L941.222 212.054Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandPlot618);
export default __webpack_public_path__ + "static/media/land_plot_618.0eb57d366b117fab4fae2bb2cf41a51e.svg";
export { ForwardRef as ReactComponent };